var V = Object.defineProperty;
var $ = (e, s, t) => s in e ? V(e, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[s] = t;
var u = (e, s, t) => ($(e, typeof s != "symbol" ? s + "" : s, t), t);
import { jsx as H } from "react/jsx-runtime";
import { createContext as J, useState as C, useMemo as X, useEffect as b, useCallback as O, useContext as Y, useRef as Z } from "react";
import { useQueryParam as m } from "use-query-params";
import k from "axios";
const N = J({});
function ue({
  Gateways: e,
  children: s
}) {
  const [t, o] = C(void 0), n = X(
    () => ({ Gateways: e, isSignedIn: t, setIsSignedIn: o }),
    [e, t]
  );
  return /* @__PURE__ */ H(N.Provider, { value: n, children: s });
}
const K = async ({
  authCode: e,
  baseURL: s
}) => {
  try {
    const {
      data: { result: t }
    } = await k.post(
      "/createNewSessionKey",
      { token: e },
      { baseURL: s }
    );
    return t;
  } catch (t) {
    throw console.error("getPermanentAccessToken:", t), new Error("Failed to retrieve permanent access token");
  }
};
let w = !1;
function ee({
  baseURL: e,
  getPermanentAccessToken: s = K
}) {
  const [t, o] = m("authCode"), [n, i] = C(!1), [a, l] = C(), [d, A] = C();
  return b(() => {
    w || (async () => {
      if (!e) {
        w = !1, i(!0);
        return;
      }
      if (!t || a) {
        if (w) {
          i(!1);
          return;
        }
        i(!0);
        return;
      }
      w = !0, i(!1), await s({ authCode: t, baseURL: e }).then((p) => {
        p && (l(p.accessToken), A(p.expiresAt));
      }).finally(() => {
        w = !1, i(!0);
      });
    })();
  }, [a, t, e, d, s]), {
    accessToken: a,
    expiresAt: d,
    setAuthCode: o,
    isCompleted: n
  };
}
const te = ({
  appId: e,
  customAuthAPIBaseURL: s,
  getPermanentAccessToken: t,
  signOutFromAPI: o
}) => {
  var F, j;
  const n = Y(N);
  if (!((F = n.Gateways) != null && F.auth))
    throw new Error("Context isn't defined");
  const i = Z(), [a, l] = m("provider"), [d, A] = m("authApiBase"), [f, p] = m("authAddress"), [T, v] = m("isMarketingAccepted"), [x, S] = m("referralCode"), [h, M] = m("walletId"), [U, q] = C(!1), c = (j = n.Gateways) == null ? void 0 : j.auth, { isSignedIn: y, setIsSignedIn: E } = n, P = s ?? d, { accessToken: B, expiresAt: R, setAuthCode: W, isCompleted: G } = ee({
    baseURL: P,
    getPermanentAccessToken: t
  });
  return b(() => {
    const L = ({ isSignedIn: Q }) => {
      E && E(Q);
    };
    return G && (i.current && (c == null || c.removeListener(i.current)), i.current = L, c == null || c.addListener(L), q(!0)), () => c == null ? void 0 : c.removeListener(L);
  }, [c, G, E]), b(() => {
    U && (y === void 0 && (B && R ? c.init({
      appId: e,
      authAddress: f,
      authBaseURL: P,
      authProvider: a,
      expiresAt: R,
      isMarketingAccepted: T,
      referralCode: x,
      signOutFromAPI: o,
      token: B,
      walletId: h
    }) : c.init({
      appId: e,
      authBaseURL: P,
      signOutFromAPI: o
    })), W(void 0, "replaceIn"), v(void 0, "replaceIn"), l(void 0, "replaceIn"), p(void 0, "replaceIn"), S(void 0, "replaceIn"), M(void 0, "replaceIn"), A(void 0, "replaceIn"));
  }, [
    B,
    e,
    c,
    f,
    P,
    a,
    R,
    U,
    T,
    y,
    x,
    p,
    A,
    W,
    l,
    v,
    S,
    M,
    o,
    h
  ]), {
    auth: c,
    isSignedIn: y
  };
}, he = ({
  appId: e,
  appPath: s,
  authPath: t,
  customAuthAPIBaseURL: o,
  getPermanentAccessToken: n,
  hasAPIKeysNotification: i,
  hasClickwrapAgreement: a = !1,
  hasReferralCodeBox: l = !1,
  referralCode: d,
  signOutFromAPI: A
}) => {
  const f = te({
    appId: e,
    customAuthAPIBaseURL: o,
    getPermanentAccessToken: n,
    signOutFromAPI: A
  }), { isSignedIn: p, auth: T } = f, v = O(() => {
    const h = new URL(t);
    return h.searchParams.set("appPath", s), h.searchParams.set("appId", e), d && h.searchParams.set("referralCode", d), l && h.searchParams.set("hasReferralCodeBox", "true"), a && h.searchParams.set("hasClickwrapAgreement", "true"), i && h.searchParams.set("hasAPIKeysNotification", "true"), h.searchParams.set("referrer", window.location.href), h;
  }, [
    e,
    s,
    t,
    i,
    a,
    l,
    d
  ]), x = O(() => {
    window.location.assign(v());
  }, [v]), S = O(async () => {
    await T.signOut();
  }, [T]);
  return {
    isSignedIn: p,
    getSignInUrl: v,
    handleSignIn: x,
    handleSignOut: S
  };
}, z = async ({ application: e, baseURL: s, token: t }) => {
  await k.post("/killSessionByToken", { application: e, token: t }, { baseURL: s });
};
var _ = /* @__PURE__ */ ((e) => (e.Google = "google", e.Github = "github", e.Web3 = "web3", e))(_ || {}), r = /* @__PURE__ */ ((e) => (e.AuthAddress = "authAddress", e.AuthProvider = "authProvider", e.ExpiresAt = "apiTokenExpiresAt", e.IsMarketingAccepted = "isMarketingAccepted", e.ReferralCode = "referralCode", e.Token = "apiToken", e.WalletId = "walletId", e))(r || {});
class se {
  constructor() {
    u(this, "listeners");
    this.listeners = [];
  }
  addListener(s) {
    this.listeners.push(s);
  }
  removeListener(s) {
    this.listeners = this.listeners.filter(
      (t) => s !== t
    );
  }
  notify(s) {
    this.listeners.forEach((t) => t(s));
  }
}
const g = (e) => (localStorage == null ? void 0 : localStorage.getItem(e)) ?? void 0, re = () => g(r.AuthProvider) ?? _.Google, I = (e, s) => {
  s && localStorage.setItem(e, s);
};
class oe extends se {
  constructor(t) {
    super();
    u(this, "api");
    u(this, "accessToken");
    u(this, "expiresAt");
    u(this, "abortController", new AbortController());
    u(this, "appId");
    u(this, "authBaseURL");
    u(this, "signOutFromAPI", z);
    this.config = t, this.api = k.create({
      ...this.config,
      signal: this.abortController.signal
    }), this.setAccessTokenInterceptor();
  }
  setAccessTokenInterceptor() {
    this.api.interceptors.request.use((t) => (this.accessToken && (t.headers.Authorization = `Bearer ${this.accessToken}`), t));
  }
  isTokenExpired() {
    return this.expiresAt && Date.now() > parseInt(this.expiresAt, 10);
  }
  init({
    appId: t,
    authAddress: o = g(r.AuthAddress),
    authBaseURL: n,
    authProvider: i = re(),
    expiresAt: a = g(r.ExpiresAt),
    isMarketingAccepted: l = g(
      r.IsMarketingAccepted
    ),
    referralCode: d = g(r.ReferralCode),
    signOutFromAPI: A = z,
    token: f = g(r.Token),
    walletId: p = g(r.WalletId)
  } = {}) {
    this.authBaseURL = n, this.signOutFromAPI = A, this.appId = t, f && a ? this.signIn({
      authAddress: o,
      authProvider: i,
      expiresAt: a,
      isMarketingAccepted: l,
      referralCode: d,
      token: f,
      walletId: p
    }) : this.signOut({ shouldSignOutFromAPI: !!f }), this.isTokenExpired() && this.signOut({ shouldSignOutFromAPI: !1 });
  }
  signIn({
    authAddress: t = void 0,
    authProvider: o,
    expiresAt: n,
    isMarketingAccepted: i,
    referralCode: a = void 0,
    token: l,
    walletId: d = void 0
  }) {
    localStorage && (I(r.Token, l), I(r.ExpiresAt, n), I(r.AuthAddress, t), I(r.AuthProvider, o), I(r.ReferralCode, a), I(r.WalletId, d), I(
      r.IsMarketingAccepted,
      i
    )), this.accessToken = l, this.expiresAt = n, this.notify({
      authAddress: t,
      authProvider: o,
      expiresAt: n,
      isMarketingAccepted: i,
      isSignedIn: !0,
      referralCode: a,
      token: l,
      walletId: d
    });
  }
  async signOut({ shouldSignOutFromAPI: t = !0 } = {}) {
    const o = this.accessToken || g(r.Token);
    if (localStorage && (localStorage.removeItem(r.Token), localStorage.removeItem(r.ExpiresAt), localStorage.removeItem(r.AuthAddress), localStorage.removeItem(r.AuthProvider), localStorage.removeItem(r.ReferralCode), localStorage.removeItem(r.WalletId), localStorage.removeItem(r.IsMarketingAccepted)), o && this.appId && this.authBaseURL && t && !this.isTokenExpired())
      try {
        await this.signOutFromAPI({
          application: this.appId,
          baseURL: this.authBaseURL,
          token: o
        });
      } catch (n) {
        console.error(n);
      }
    this.accessToken = void 0, this.expiresAt = void 0, this.abortController.abort(), this.notify({
      authAddress: void 0,
      authProvider: void 0,
      expiresAt: void 0,
      isMarketingAccepted: void 0,
      isSignedIn: !1,
      referralCode: void 0,
      token: void 0,
      walletId: void 0
    });
  }
}
class ne {
  constructor(s) {
    u(this, "api");
    this.config = s, this.api = k.create({
      ...this.config
    });
  }
}
const D = {
  headers: {
    "Content-Type": "application/json"
  },
  responseType: "json"
};
function pe({
  baseURL: e,
  withCredentials: s = !0
}) {
  class t {
  }
  return u(t, "auth", new oe({
    ...D,
    baseURL: e,
    withCredentials: s
  })), u(t, "noAuth", new ne({
    ...D,
    baseURL: e,
    withCredentials: s
  })), t;
}
const fe = async ({ authCode: e, baseURL: s }) => {
  const { data: t } = await k.post(
    "/auth/session/ui/new",
    { token: e },
    { baseURL: s }
  );
  return { accessToken: t.access_token, expiresAt: t.expires_at };
}, Ae = async ({ baseURL: e, token: s }) => {
  await k.post("/auth/session/ui/logout", void 0, {
    baseURL: e,
    headers: {
      Authorization: `Bearer ${s}`
    }
  });
};
export {
  ue as AuthContextProvider,
  _ as AuthProvider,
  r as LocalStorageKey,
  pe as createGateways,
  fe as getPermanentAccessTokenWithCookie,
  z as signOut,
  Ae as signOutAndClearCookies,
  he as useAuth
};
